/* Caveau - menu principale (snippets/caveau-nav.liquid, stile in assets/caveau-nav.css).
   Computer (da 992 px): i pannelli si aprono al passaggio del mouse (piccola attesa per non aprirli per sbaglio) e al clic;
   Esc chiude, freccia giù entra nel pannello, clic fuori o Tab fuori chiude. Un pannello aperto dal mouse resta aperto se
   poi si clicca sulla voce (il clic non lo richiude subito).
   Telefono e tablet (menu laterale): le voci si aprono e chiudono a fisarmonica.
   I clic sono gestiti sul documento: il menu laterale del tema sposta il menu dentro <body> quando si apre. */
(() => {
  if (window.cvNavReady) return;
  window.cvNavReady = true;

  const desktop = window.matchMedia('(min-width: 992px)');
  const mouse = window.matchMedia('(hover: hover) and (pointer: fine)');
  let openTimer = 0;
  let closeTimer = 0;
  let mouseOpened = null;

  const items = () => [...document.querySelectorAll('[data-cv-nav-item]')];
  const openerOf = (item) => item.querySelector('[data-cv-nav-opener]');
  const panelOf = (item) => item.querySelector('[data-cv-nav-panel]');

  /* Tendina piccola: sotto la sua voce, senza uscire dalla riga dell'header. */
  const place = (item) => {
    if (!desktop.matches || !item.classList.contains('cv-nav__item--drop')) return;
    const row = item.closest('.cv-hrow');
    const opener = openerOf(item);
    const panel = panelOf(item);
    if (!row || !opener || !panel) return;
    const rowBox = row.getBoundingClientRect();
    const box = opener.getBoundingClientRect();
    const width = panel.offsetWidth || 260;
    const x = Math.max(12, Math.min(box.left - rowBox.left - 24, rowBox.width - width - 12));
    panel.style.setProperty('--cv-x', Math.round(x) + 'px');
  };

  const setOpen = (item, open) => {
    if (!item) return;
    if (open) place(item);
    item.classList.toggle('is-open', open);
    const opener = openerOf(item);
    if (opener) opener.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (!open && mouseOpened === item) mouseOpened = null;
  };

  const closeAll = (keep) => {
    items().forEach((item) => {
      if (item !== keep && item.classList.contains('is-open')) setOpen(item, false);
    });
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-cv-nav-opener]');
    if (opener) {
      const item = opener.closest('[data-cv-nav-item]');
      if (!item) return;
      event.preventDefault();
      clearTimeout(openTimer);
      const isOpen = item.classList.contains('is-open');
      if (desktop.matches && mouse.matches && isOpen && mouseOpened === item) {
        mouseOpened = null;
        return;
      }
      if (desktop.matches) closeAll(item);
      setOpen(item, !isOpen);
      return;
    }
    if (desktop.matches && !event.target.closest('[data-cv-nav-panel]')) closeAll(null);
  });

  const onEnter = (item) => {
    if (!desktop.matches || !mouse.matches) return;
    clearTimeout(closeTimer);
    clearTimeout(openTimer);
    if (item.classList.contains('is-open')) return;
    const another = items().some((other) => other !== item && other.classList.contains('is-open'));
    openTimer = setTimeout(() => {
      closeAll(item);
      setOpen(item, true);
      mouseOpened = item;
    }, another ? 0 : 110);
  };

  const onLeave = (item) => {
    if (!desktop.matches || !mouse.matches) return;
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeTimer = setTimeout(() => setOpen(item, false), 240);
  };

  const bind = () => {
    items().forEach((item) => {
      if (item.dataset.cvNavBound) return;
      item.dataset.cvNavBound = '1';
      item.addEventListener('mouseenter', () => onEnter(item));
      item.addEventListener('mouseleave', () => onLeave(item));
    });
  };
  bind();
  document.addEventListener('DOMContentLoaded', bind);
  document.addEventListener('shopify:section:load', bind);

  document.addEventListener('keydown', (event) => {
    const item = event.target.closest ? event.target.closest('[data-cv-nav-item]') : null;
    if (!item) return;
    if (event.key === 'Escape' && item.classList.contains('is-open')) {
      setOpen(item, false);
      const opener = openerOf(item);
      if (opener) opener.focus();
    } else if (event.key === 'ArrowDown' && desktop.matches && event.target.matches('[data-cv-nav-opener]')) {
      event.preventDefault();
      closeAll(item);
      setOpen(item, true);
      const first = panelOf(item) && panelOf(item).querySelector('a');
      if (first) setTimeout(() => first.focus(), 30);
    }
  });

  document.addEventListener('focusin', (event) => {
    if (!desktop.matches) return;
    items().forEach((item) => {
      if (item.classList.contains('is-open') && !item.contains(event.target)) setOpen(item, false);
    });
  });

  window.addEventListener('resize', () => {
    items().forEach((item) => {
      if (item.classList.contains('is-open')) place(item);
    });
  });
  const reset = () => {
    clearTimeout(openTimer);
    clearTimeout(closeTimer);
    closeAll(null);
  };
  if (desktop.addEventListener) desktop.addEventListener('change', reset);
  window.addEventListener('pageshow', (event) => {
    if (event.persisted) reset();
  });
})();
